import { useState, type FormEvent } from "react";
import { api, errorMessage } from "../api/client";
import { useApp } from "../state";

const NAMES: Record<string, [string, string]> = {
  google: ["G", "Continue with Google"],
  facebook: ["f", "Continue with Facebook"],
};

/** One button per provider the server offers. Real providers are full-page navigations to the API. */
export function SignInButtons({ next, onSignedIn }: { next: string; onSignedIn?: () => void }) {
  const { me, setMe } = useApp();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const providers = me.auth_providers.filter((p) => p !== "dev");
  const dev = me.auth_providers.includes("dev");

  const devSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      setMe(await api.devSignIn(name.trim() || "Heidi"));
      onSignedIn?.();
    } catch (x) {
      setErr(errorMessage(x));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="stack">
      {providers.map((p) => {
        const [mark, label] = NAMES[p] ?? [p.charAt(0).toUpperCase(), "Continue with " + p.charAt(0).toUpperCase() + p.slice(1)];
        return (
          <a key={p} className="btn" href={api.loginUrl(p, next)}>
            <span className="pmark" aria-hidden="true">
              {mark}
            </span>
            {label}
          </a>
        );
      })}
      {dev && (
        <form className="stack devform" onSubmit={devSubmit} noValidate>
          <label className="eyebrow" htmlFor="dev-name">
            Dev sign-in
          </label>
          <div className="seam">
            <input id="dev-name" autoComplete="given-name" placeholder="First name" value={name} onChange={(e) => setName(e.target.value)} />
            <button className="btn" type="submit" disabled={busy}>
              Sign in
            </button>
          </div>
          {err && <p className="hint warn">{err}</p>}
        </form>
      )}
      {!providers.length && !dev && <p className="hint">Sign-in isn't available right now. You can keep using Drape as a guest.</p>}
    </div>
  );
}
